
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_vdkpj_1sxw4_181",
  "item-wrapper": "awsui_item-wrapper_vdkpj_1sxw4_217",
  "group": "awsui_group_vdkpj_1sxw4_221",
  "divider": "awsui_divider_vdkpj_1sxw4_225"
};
  